import React from "react";

const WeatherBanner = () => (
    <div id="weatherBanner" className="ui segment image">
        <a href="https://github.com/WebDevelopUa/weather" target="_blank" rel="noopener noreferrer">
            <img src="https://via.placeholder.com/468x60/009C95/FFFFFF?text=VISIT+APP+REPO+BANNER" alt="BANNER"/>
        </a>
    </div>
)


export default WeatherBanner


